// CSS Modules - component class name prefix: ElasticSearch__

<template>
  <div :class="$style.container">
    <Search
      :searchPlaceholder="config.placeholder"
      :selectedSuggestion="selectedSuggestion"
      :model="model"
      @submitted="submitSearch"
      @active="getSearchResults"
      @inactive="active = false"
    />
    <ul
      v-if="suggestions.length !== 0"
      v-show="active"
      :class="$style.suggestions"
    >
      <li
        v-for="(suggestion, index) in suggestions"
        :class="$style.suggestion"
        :key="index"
        @click="() => handleSuggestionClick(suggestion.text)"
      >
        <span v-html="suggestion.text"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";
import Search from "../Search/Search";

export default {
  name: "ElasticSearch",
  components: {
    Search
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    model: {
      type: Array,
      default: () => []
    }
  },
  data: () => {
    return {
      suggestions: [],
      selectedSuggestion: "",
      active: false,
      isShop: window.instance === "shop"
    };
  },
  methods: {
    submitSearch(terms) {
      if (this.config.headerSearch) {
        const queryTerms = terms.toString().replace(/,/g, "+");
        const submitUrl =
          this.config.submitUrl +
          (queryTerms ? `?wika-search=${queryTerms}` : "");
        window.location = submitUrl;
      } else if (terms[0] !== "") {
        this.active = false;
        this.$emit("submitted", terms);
      }
    },
    getSearchResults(terms) {
      if (!terms.length || (terms.length === 1 && terms[0].length < 2)) {
        this.emptySuggestions();
      } else {
        let container = "web";
        this.isShop ? (container = "shop") : (container = "web");
        axios({
          url: window.suggestSearchUrl,
          method: "post",
          data: {
            word: terms,
            language: window.currentLanguage,
            country:
              window.currentCountry.toLowerCase() === "gb"
                ? "en"
                : window.currentCountry, // TODO: think of better solution/ technical concept for this quick fix
            container: container
          }
        })
          .then(response => this.processSearch(response.data))
          .catch(error => console.error(error));
      }
    },
    emptySuggestions() {
      this.active = false;
      this.suggestions = [];
    },
    processSearch(data) {
      this.active = true;
      this.suggestions = data.suggest["prefix-suggest"][0].options;
    },
    handleSuggestionClick(suggestion) {
      this.selectedSuggestion = suggestion;
      this.active = false;
    }
  }
};
</script>

<style module lang="scss">
@import "./ElasticSearch.scss";
</style>
